import { findAllOccurrences } from '@morph-mapper/utils';
import { getFinalResultKey } from '../../hooks/use-render-template';

export const withPositionSelection =
  <TData>(selectData: (renderedData: unknown) => TData) =>
  (renderedData: unknown) => {
    const data = selectData(renderedData);
    const position = findAllOccurrences(renderedData, 'position');
    return { data, position };
  };

export const findEntryResults = (value: unknown, entryId: string) => {
  const finalMatches = findAllOccurrences(value, getFinalResultKey(entryId));
  if (finalMatches.length > 0) return finalMatches;

  return findAllOccurrences(value, `__reserved__key__${entryId}`);
};

export const extractGraphResult = (value: unknown, entryId: string) => {
  const matches = findEntryResults(value, entryId);
  if (matches.length === 1) return matches[0];
  if (matches.length > 1) return matches;
  return undefined;
};
